import React from "react";
import SectionView from "../../../Common/Views/SectionView";
import {useCollectionData} from "react-firebase-hooks/firestore";
import Firebase from "firebase";
import FeaturedLink from "../../../Common/Models/FeaturedLink";
import FeaturedLinkListItem from "../../../Common/Views/ListItems/FeaturedLinkListItem";
import openWebPage from "../../../Common/Helper/openWebPage";

const PlannerFeaturedLinksView = () => {
    const [links] = useCollectionData<FeaturedLink>(Firebase.firestore().collection('DefaultLinks').doc('Planner').collection('Links').orderBy('Order'));
    const onClick = (item: FeaturedLink) => {
        openWebPage(item.url)
    };

    const displayLinks = (links: FeaturedLink[]) =>
        links.map((link) =>
            <FeaturedLinkListItem
                key={link.Order}
                item={link}
                displayFavorite={false}
                onClick={onClick}
            />);

    return (
        <>
            {links &&
                <SectionView disableGutters>
                    {displayLinks(links)}
                </SectionView>
            }
        </>
    );
};

export default PlannerFeaturedLinksView;